var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import { SvgCircleIcon } from './svg-circle-icon';
export var XIcon = function (props) {
  return React.createElement(SvgCircleIcon, __assign({}, props, {
    glyphWidth: 53,
    glyphHeight: 49
  }), React.createElement("path", {
    d: "M0.668468 0.00488281L20.7451 26.8492L0.541687 48.6748H5.08866L22.7767 29.5662L37.0682 48.6748H52.5417L31.3355 20.3205L50.1406 0.00488281H45.5937L29.3039 17.6036L16.142 0.00488281H0.668468ZM7.35513 3.35419H14.4637L45.854 45.325H38.7454L7.35513 3.35419Z"
  }));
};
export var XIconGlyph = function (props) {
  return React.createElement(XIcon, __assign({}, props, {
    variant: 'glyph'
  }));
};